import { Component } from '@angular/core';

@Component({
    selector: 'mesc-user-profile',
    templateUrl: './user-profile.component.html',
    // styleUrls: ['./users.component.scss']
})

export class UserProfileComponent {
    moduleGroups: any[] = [];
    moduleName: string;
    groupDisplayName: string;

    setContent(data: any[]) { }
}